import { configureStore } from "@reduxjs/toolkit";
import globalReducer from "./slices/globalSlice";
import grievancesReducer from "./slices/grievancesSlice";
import loginReducer from "./slices/loginSlice"
import dashboardReducer from "./slices/dashboardSlice";
import roleMasterReducer from "./slices/roleMasterSlice";

export const store = configureStore({
  reducer: {
    login: loginReducer,
    global: globalReducer,
    grievances: grievancesReducer,
    dashboard: dashboardReducer,
    roleMaster: roleMasterReducer
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
